export enum SHIPPING_TYPES {
  SELF = 'self',
  COURIER = 'courier',
}

export enum PAYMENT_TYPES {
  CASH = 'cash',
  ONLINE = 'online',
}
